import { TaxonomyConceptType } from 'app/api/tag-queries';
import { i18n } from 'app/utils/i18n';
import { getConceptNarrowType, isEscapedConceptType } from './getConceptNarrowType';
import { isFractionConceptType } from './isFractionConceptType';

export const getConceptTypeContent = (conceptType: TaxonomyConceptType) => {
  const { isNumeric, isAbstract, isMonetary } = conceptType;
  const narrow = getConceptNarrowType(conceptType);
  switch (true) {
    case isAbstract:
      return { conceptLabel: i18n('tag.concept.type.abstract'), icon: <i className="fa-light fa-sitemap"></i> };
    case isEscapedConceptType(conceptType):
      return { conceptLabel: i18n('tag.concept.type.text-block'), icon: <i className="fa-solid fa-text"></i> };
    case narrow === 'enumerationItemType' || narrow === 'enumerationSetItemType':
      return { conceptLabel: i18n('tag.concept.type.enumeration'), icon: <i className="fa-solid fa-list-check"></i> };
    case isFractionConceptType(conceptType):
      return { conceptLabel: i18n('tag.concept.type.fraction'), icon: <i className="fa-solid fa-divide"></i> };
    case narrow === 'perShareItemType':
      return { conceptLabel: i18n('tag.concept.type.per-share'), icon: <i className="fa-solid fa-slash-forward"></i> };
    case narrow === 'percentItemType':
      return { conceptLabel: i18n('tag.concept.type.percent'), icon: <i className="fa-solid fa-percent"></i> };
    case narrow === 'monetaryItemType' || isMonetary:
      return { conceptLabel: i18n('tag.concept.type.monetary'), icon: <i className="fa-regular fa-grid-2"></i> };
    case isNumeric:
      return { conceptLabel: i18n('tag.concept.type.numeric'), icon: <i className="fa-solid fa-hashtag"></i> };
    case narrow === 'booleanItemType':
      return { conceptLabel: i18n('tag.concept.type.boolean'), icon: <i className="fa-solid fa-toggle-on"></i> };
    case narrow === 'dateItemType':
      return { conceptLabel: i18n('tag.concept.type.date'), icon: <i className="fa-regular fa-calendar"></i> };
    case narrow === 'domainItemType':
      return { conceptLabel: i18n('tag.concept.type.domain-member'), icon: <i className="fa-regular fa-diagram-subtask"></i> };
    case narrow === 'stringItemType':
      return { conceptLabel: i18n('tag.concept.type.string'), icon: <i className="fa-solid fa-font"></i> };
    default:
      return { conceptLabel: i18n('tag.concept.type.other'), icon: <i className="fa-regular fa-diagram-nested"></i> };
  }
};
